const isExternalHref = (href: string) => href.includes("://");

export default isExternalHref;
